import React from "react";
import { Route } from "react-router-dom";
import AccessControl from "../../../components/utilities/Class/AccessControl";
import ListPayment from "../../../containers/modules/accounting/list-payment";

export default function ListPaymentRoute(props) {
  const { authUser } = props;
  return (
    <Route
      path="list-payment"
      index
      element={
        <AccessControl
          name={"List Payment"}
          auth={authUser}
          component={() => <ListPayment />}
        />
      }
    />
  );
}
